import { render, staticRenderFns } from "./OperateClientDialog.vue?vue&type=template&id=23519499&scoped=true"
import script from "./OperateClientDialog.vue?vue&type=script&lang=js"
export * from "./OperateClientDialog.vue?vue&type=script&lang=js"
import style0 from "./OperateClientDialog.vue?vue&type=style&index=0&id=23519499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23519499",
  null
  
)

export default component.exports